import { all, call, CallEffect, fork, put, PutEffect, takeEvery, } from "redux-saga/effects";
import { fetchLetterBodySuccess } from "../actions/LetterBody";
import { ActionTypes } from "../../constants/ActionTypes";
import { ShowError } from "../../helper/Alert";
import FaraGostarDynamicHttp from "../../api/FaraGostarDynamicHttp";
import { AxiosResponse } from "axios";

// recent letterBody
const getLetterBody = async (letterCode: string) => {
    let http = await FaraGostarDynamicHttp();
    return await http.get(`letterBody/GetLetterBodyPageInfo?letterCode=${letterCode}`);
}

function* fetchLetterBodyRequest(action: any): Generator<CallEffect<AxiosResponse<any>> | PutEffect<{ type: ActionTypes; payload: any; }>, void, AxiosResponse<any>> {
    try {
        const fetchedLetterBody = yield call(getLetterBody, action.letterCode);
        yield put(fetchLetterBodySuccess(fetchedLetterBody.data));
    } catch (error) {
        return ShowError("", error);
    }
}

export function* fetchLetterBody() {
    yield takeEvery(ActionTypes.GET_LetterBody, fetchLetterBodyRequest);
}

export default function* rootSaga() {
    yield all([fork(fetchLetterBody)]);
}
